import styled from '@emotion/styled';
import MicrositeHero from '~/components/MicrositeHero';
import { DEMO_PHOTOS } from '~/demo';

interface HeroBlockEpsilonProps {
	address1?: string;
	address2?: string;
}

const Wrapper = styled.section`
	position: relative;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	color: white;
`;

const Background = styled.div`
	position: absolute;
	inset: 0;
	z-index: 0;
`;

const Content = styled.div`
	position: relative;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.5rem;
`;

const Title = styled.h1`
	font-size: 4.5rem;
	text-shadow: 1px 1px 2px rgba(17, 17, 17, 0.26);
`;

const Subtitle = styled.div`
	font-size: 2rem;
	text-shadow: 1px 1px 2px rgba(17, 17, 17, 0.26);
`;

const TourLink = styled.a`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	color: white;
	text-decoration: none;
`;

const TourIcon = styled.div`
	width: 4.5rem;
	height: 4.5rem;
	border-radius: 999px;
	background: rgba(0, 0, 0, 0.5);
	display: grid;
	place-items: center;
`;

const TourLabel = styled.div`
	font-size: 1.75rem;
	text-shadow: 1px 1px 2px rgba(17, 17, 17, 0.26);
`;

export default function HeroBlockEpsilon({ address1, address2 }: HeroBlockEpsilonProps) {
	return (
		<Wrapper>
			<Background>
				<MicrositeHero image={DEMO_PHOTOS[0]} />
			</Background>
			<Content>
				{address1 && <Title>{address1}</Title>}
				{address2 && <Subtitle>{address2}</Subtitle>}
				<TourLink href="#tours">
					<TourIcon>⌂</TourIcon>
					<TourLabel>View Virtual Tour</TourLabel>
				</TourLink>
			</Content>
		</Wrapper>
	);
}
